// Constants for external ID generation
const EXTERNAL_ID_LENGTH = 12;

/**
 * Generate a random external ID with 12 alphanumeric characters
 */
export const generateExternalId = (): string => {
  const chars =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < EXTERNAL_ID_LENGTH; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

/**
 * Compute the redirect URI from the template, slug, and external ID
 */
export const computeRedirectUri = (
  template: string,
  externalId: string
): string => template.replace("{external_id}", externalId);
